import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import { DateRangeService } from './date-range.service'

/**
 * @ngdoc filter
 * @name mwDateRangeThisYear
 * @module mw.components.dateRange
 *
 * @param {Date} relativeDate - Relative date.
 * @param {string} [format] - Formatting rules (see momentjs formatting rules https://momentjs.com/docs/#/displaying/format/). If not specified, 'MMM D' is used.
 * @param {string} [timezone] - Timezone to be used for formatting the date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 * @param {string} [locale] - Locale used for formatting the date range.  If not specified, the browser locale will be used.
 *
 * @returns {string} Formatted date range string.
 *
 * @description
 * `mwDateRangeThisYear` filter converts a relative `Date` object to a `DateRange` and formats it to a string.  Start Date will be the beginning of the year prior to the current `relativeDate` input is in.  End Date will be the `relativeDate` input.
 *
 */
@Pipe({ name: 'mwDateRangeThisYear' })
export class DateRangeThisYearPipe implements PipeTransform {
    private mwDateRangePipe;

    constructor(
        @Inject('mwDateRangeService') private dateRangeService: DateRangeService,
        @Inject('$filter') private $filter: any) {
        this.mwDateRangePipe = $filter('mwDateRange');
    }

    transform(date: Date, format: string, timezone: string, locale: string): string {
        return this.mwDateRangePipe(this.dateRangeService.thisYear(date, timezone), format, timezone, locale);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range-this-year.pipe.ts